import React, { useState, useEffect, Fragment } from "react";
import Button from "../../../../lib/ui/buttons/Button";
import InputField from '../../../../lib/ui/inputs/Input';
import Checkbox from "../../../../lib/ui/checkbox/Checkbox";
import PhoneInput, { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css'
import '../../../../lib/ui/imageicon/Styles.css';
import "../../../../layouts/Layouts.css";
import Loader from "../../../../lib/ui/loader/Loader";
import DropDown from "../../../../lib/ui/dropdown/Dropdown";
import AddrDropDown from "../../../../lib/ui/dropdown/addressDropDown";
import { createUser, updateUser, getUserDetails, getAllAdmins } from "../../../../actions/users";
import { useHistory } from 'react-router-dom';
import { validateEmail, validateLetters, validatePincode, validateIntegers } from '../../../../lib/validation';
import statesList from "../../../../config/states.json";
import citiesList from "../../../../config/cities.json";
import countriesList from "../../../../config/countries.json";
import { toast } from 'react-toastify';
import VerifyPopup from "../../users/components/VerifyPopup";
// import config from '../../../../config.json';
import {API} from 'aws-amplify';



const CreateClinicForm = (props) => {
    const history = useHistory();
    const { cId, l, role, userId } = props;
    const [loading, setLoading] = useState(false);

    const [errorMsg, setErrorMsg] = useState(null);
    const [error, setError] = useState({});
    const [clinicName, setClinicName] = useState('');
    const [contactName, setContactName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [pincode, setPincode] = useState('');
    // const [doctorCount, setDoctorCount] = useState('');
    const [address, setAddress] = useState('');
    const [states, setStates] = useState([{
        value: "",
        label: l.select_state
    },]);
    const [cities, setCities] = useState([{
        value: "",
        label: l.select_city
    },]);
    const [country, setCountry] = useState('India');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [advice, setAdvice] = useState(false);
    const [uploadPrescription, setUploadPrescription] = useState(false);
    const [prescription, setPrescription] = useState(false);
    const [screenShare, setScreenShare] = useState(false);
    const [openPopup, setopenPopup] = useState(false)
    const [admins, setAdmins] = useState([]);
    const [assignTo, setAssign] = useState('');
    const [domainName, setDomainName] = useState('');
    const [doctorsCount, setDoctorsCount] = useState('');
    // const [poolId, setPoolId] = useState('');
    // const [identityId, setIdentityId] = useState('');
    // const [appClientId, setAppClientId] = useState('');

    useEffect(() => {
        if (role === "SA") {
            getAllAdmins().then(res => {
                let _admins = [{
                    value: "",
                    label: l.select_admin
                }]
                res.data.forEach(ad => {
                    _admins.push({
                        label: ad.companyName,
                        value: ad.userId
                    })
                });
                setAdmins(_admins);
            }).catch(err => {
                console.log("err in all admin ==== ", err);
            })
        } else if (role === "CA") {
            setAssign(userId)
        }
    }, [role, userId]);

    useEffect(() => {
        if (cId) {
            setLoading(true);
            getUserDetails(cId).then(res => {
                setLoading(false);
                if (res.status) {
                    const { data } = res;
                    setClinicName(data.clinicName);
                    setContactName(data.contactName);
                    setEmail(data.email);
                    setPhone('+' + data.countryCode + data.phone);
                    setAddress(data.address);
                    setCountry(data.country)
                    setState(data.stateName);
                    setCity(data.city);
                    setPincode(data.pincode);
                    setAdvice(data.doctorPrivligies.advice);
                    setUploadPrescription(data.doctorPrivligies.uploadPrescription);
                    setPrescription(data.doctorPrivligies.prescription);
                    data.patientPriviligies  && setScreenShare(data.patientPriviligies.screenShare);
                    data.adminId && setAssign(data.adminId);
                    (!data.adminId) && setAssign(data.consultId)
                    setDoctorsCount(data.doctorsCount);
                    setDomainName(data.subdomain);

                    // console.log(doctorsCount,domainName)
                    // setPoolId(data.poolId ? data.poolId : '');
                    // setIdentityId(data.identityId ? data.identityId : '');
                    // setAppClientId(data.appClientId ? data.appClientId : '');
                }
            }).catch(err => {
                if(API.isCancel(err)) {
                    console.log("API is canceled................");
                } else {
                    setLoading(false);
                }
                console.log("err ==== ", err);
            })
        }
    }, [props.active, cId]);

    useEffect(() => {
        let _statesList = statesList.filter((state) => state.countryid === country);
        _statesList.unshift({
            value: "",
            label: l.select_state
        });
        _statesList.sort((a,b)=> a.value < b.value? -1:a.value > b.value? 1:0)
        setStates([..._statesList]);
        setCity(''); 
        setCities([{ value: "", label: l.select_city }]);
    }, [country]);

    useEffect(() => {
        let _citiesList = citiesList.filter((city) => city.stateid === state);
        if (_citiesList.length === 0) {
            _citiesList = [{
                value: "",
                label: l.no_cities_available
            }];
        } else {
            _citiesList.unshift({
                value: "",
                label: l.select_city
            });
        }
        _citiesList.sort((a,b)=> a.value < b.value? -1:a.value > b.value? 1:0)
        setCities(_citiesList);
    }, [state]);

    const validateForm = () => {
        let _error = {};
        let returnValue = true;

        if (clinicName === '' || clinicName == null) {
            _error['clinicName'] = l.pls_ent_clcName
            returnValue = false
        }
        else if (!validateLetters(clinicName)) {
            _error['clinicName'] = l.pls_ent_clc_contact

            returnValue = false;
        }
        if (contactName === '' || contactName == null) {
            _error['contactName'] = l.pls_ent_contName
            returnValue = false
        }
        else if (!validateLetters(contactName)) {
            _error['contactName'] = l.pls_ent_clc_contact
            returnValue = false;
        }
        if (email === '' || email == null) {
            _error['email'] = l.pls_enter_email
            returnValue = false
        }
        else if (!validateEmail(email)) {
            _error['email'] = l.pls_check_email
            returnValue = false
        }
        if (phone === '' || phone == null) {
            _error['phone'] = l.pls_enter_phone
            returnValue = false
        }
        else if (!isValidPhoneNumber(phone)) {
            _error['phone'] = l.pls_check_phone
            returnValue = false
        }
        // if (country === '' || country == null) {
        //     _error['country'] = l.pls_sel_country
        //     returnValue = false
        // }
        // if (state === '' || state == null) {
        //     _error['state'] = l.pls_sel_state
        //     returnValue = false
        // }
        // if (city === '' || city == null) {
        //     _error['city'] = l.pls_sel_city
        //     returnValue = false
        // }
        // if (pincode === '' || pincode === null) {
        //     _error['pincode'] = l.pls_entr_pin
        //     returnValue = false
        // }

        if(pincode === '' || pincode === null){
            _error['pincode'] = l.pls_entr_pin
            returnValue = false
        }
        else if (!validatePincode(pincode)) {
            _error['pincode'] = l.pls_check_pin
            returnValue = false
        }
        if (domainName === '' || domainName === null) {
            _error['domainName'] = l.pls_entr_domain
            returnValue = false
        }
        else if (!validateLetters(domainName)) {
            _error['domainName'] = l.pls_check_domain
            returnValue = false
        }

        // if (!cId && domainName !== config.defaultdomian && (poolId === '' || poolId === null)) {
        //     _error['poolId'] = l.pls_entr_pool_id
        //     returnValue = false
        // } else if (!cId && domainName !== config.defaultdomian && poolId !== "" && !validateKeys(poolId)) {
        //     _error['poolId'] = l.pls_ent_valid_pool_id
        //     returnValue = false
        // }

        // if (!cId && domainName !== config.defaultdomian && (identityId === '' || identityId === null)) {
        //     _error['identityId'] = l.pls_entr_identity_pool_id
        //     returnValue = false
        // } else if (!cId && domainName !== config.defaultdomian && identityId !== "" && !validateKeys(identityId)) {
        //     _error['identityId'] = l.pls_ent_valid_ide_pool_id
        //     returnValue = false
        // }

        // if (!cId && domainName !== config.defaultdomian && (appClientId === '' || appClientId === null)) {
        //     _error['appClientId'] = l.pls_entr_app_client_id;
        //     returnValue = false
        // } else if (!cId && domainName !== config.defaultdomian && appClientId !== "" && !validateKeys(appClientId)) {
        //     _error['appClientId'] = l.pls_ent_valid_app_client_id
        //     returnValue = false
        //}
        // if (doctorsCount === '' || doctorsCount === null) {
        //     _error['doctorsCount'] = l.pls_enter_doctors
        //     returnValue = false
        // }
        if (assignTo === '' || assignTo === null) {
            _error['assignTo'] = l.pls_selt_admin
            returnValue = false
        }
        if (doctorsCount === '' || doctorsCount === null) {
            _error['doctorsCount'] = l.pls_entr_dctrcount
            returnValue = false
        }
        else if (!validateIntegers(doctorsCount) || doctorsCount > 100) {
            _error['doctorsCount'] = l.pls_check_dctrcount
            returnValue = false
        }

        console.log(_error)

        setError(_error);
        return returnValue;
    }

    const handleCancel = () => {
        history.push('/admin-users/clinic');
    }

    const handleCreateClinic = async (e) => {
        e.preventDefault();
        try {
            if (validateForm()) {
                setLoading(true);
                const phoneNumber = parsePhoneNumber(phone)
                const countrycode = phoneNumber.countryCallingCode;
                const number = phoneNumber.nationalNumber;
                let body = {
                    clinicName: clinicName.trim(),
                    firstName: clinicName.trim(),
                    lastName: '',
                    consultRole: 'clinic',
                    contactName: contactName.trim(),
                    email: email.trim(),
                    countryCode: countrycode,
                    phone: number.trim(),
                    address: address.trim() ? address.trim() : '',
                    country: country ? country : '',
                    stateName: state ? state : '',
                    city: city ? city : '',
                    pincode: pincode.trim() ? pincode.trim() : '',
                    doctorsCount: doctorsCount,
                    doctorPrivligies: {
                        advice: advice,
                        uploadPrescription: uploadPrescription,
                        prescription: prescription
                    },
                    patientPriviligies: {
                        screenShare: screenShare
                    },
                    adminId: assignTo,
                    subdomain: domainName.toLowerCase()
                }
                // if (domainName !== config.defaultdomian) {
                //     body["poolId"] = poolId;
                //     body["identityId"] = identityId;
                //     body["appClient"] = appClientId;
                // }
                if (cId) {
                    updateUser(cId, body).then(res => {
                        setLoading(false);
                        if (res.status) {
                            toast.success(l.clinic_update_succ, {
                                position: toast.POSITION.TOP_RIGHT
                            })
                            history.push('/admin-users/clinic');
                        }
                    }).catch(err => {
                        setLoading(false);
                        let msg = err?.response?.data?.error?.message ? err.response.data.error.message : err?.response?.data?.error ? err.response.data.error : l.unable_upd_clinic;
                        toast.error(msg, {
                            position: toast.POSITION.TOP_RIGHT
                        })
                        setErrorMsg(msg)
                    })
                }
                else {
                    createUser(body).then(res => {
                        setLoading(false);
                        if (res.status) {
                            toast.success("Clinic created successfully", {
                                position: toast.POSITION.TOP_RIGHT
                            })
                            history.push('/admin-users/clinic');
                        }
                    }).catch(err => {
                        setLoading(false);
                        console.log("error in create user=======", err.response);
                        let msg = err?.response?.data?.error?.message ? err.response.data.error.message : err?.response?.data?.error ? err.response.data.error : l.unable_crt_clinic;

                        toast.error(msg, {
                            position: toast.POSITION.TOP_RIGHT
                        })
                        setErrorMsg(msg)
                    });
                }
            }
            else {
                if (errorMsg != null) {
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                }
            }
        } catch (err) {
            setLoading(false);
            let msg = err?.response?.data?.error ? err.response.data.error : err.errorMessage;
            toast.error(msg, {
                position: toast.POSITION.TOP_RIGHT
            })

            setErrorMsg(l.went_worng_pls_try_again)
        }
    }
    const handleVerify = () => {
        setopenPopup(prevState => !prevState);
        history.push('/admin-users/clinic');
        toast.success("Clinic created successfully", {
            position: toast.POSITION.TOP_RIGHT
        })
    }

    return (
        loading ? <Loader /> : <Fragment>
            <div className="formCol">

                <div className="formListGroup">
                    {errorMsg &&
                        <div className="errorBox">
                            <small className="errorTxt">{errorMsg}</small>
                        </div>
                    }
                    <div className="colBlock">
                        <form onSubmit={handleCreateClinic}>
                            <small className="inpLabel">{l.edit_clc_name}<span className="redTxt">*</span>:</small>
                            <InputField
                                placeholder={l.edit_clc_name}
                                type="text"
                                value={clinicName}
                                error={error && error.clinicName}
                                errorMsg={error.clinicName}
                                maxLength="30"
                                onChange={(e) => setClinicName(e.target.value)}
                            />
                            <small className="inpLabel">{l.edit_clc_contact_name}<span className="redTxt">*</span>:</small>
                            <InputField
                                placeholder={l.edit_clc_contact_name}
                                type="text"
                                value={contactName}
                                error={error && error.contactName}
                                errorMsg={error.contactName}
                                maxLength="30"
                                onChange={(e) => setContactName(e.target.value)}
                            />
                            <small className="inpLabel">{l.email_address}<span className="redTxt">*</span>:</small>
                            {cId ?
                            <div className="pTxt">{email}</div> : <InputField
                            placeholder={l.email_address}
                            type="text"
                            value={email}
                            maxLength="50"
                            error={error && error.email}
                            errorMsg={error.email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        }


                                <small className="inpLabel">{l.edit_phone_no}<span className="redTxt">*</span>:</small>
                                <div className="inputBox colBlock nopdng">
                                    <PhoneInput className="customPkgInput nopdng"
                                        international
                                        countryCallingCodeEditable={false}
                                        defaultCountry="IN"
                                        value={phone}
                                        maxLength="17"
                                        // error={error && error.phone}
                                        // errorMsg={error.phone}
                                        onChange={setPhone} />
                                    <label>{props.label}</label>
                                    {(error && error.phone) && <span className="inputErrorMsg">{error.phone}</span>}
                                </div>

                            <small className="inpLabel">{l.edit_address}:</small>
                            <InputField
                                placeholder={l.edit_address}
                                type="text"
                                value={address}
                                error={error && error.address}
                                errorMsg={error.address}
                                maxLength="100"
                                onChange={(e) => setAddress(e.target.value)}
                            />
                            <small className="inpLabel">{l.select_country}<span className="redTxt">*</span>:</small>
                            <AddrDropDown
                                placeholder={l.select_country}
                                items={countriesList}
                                value={country}
                                error={error && error.country}
                                errorMsg={error.country}
                                onChange={(e) => setCountry(e.target.value)}
                            />
                            <small className="inpLabel">{l.select_state}<span className="redTxt">*</span>:</small>
                            <AddrDropDown
                                placeholder={l.select_state}
                                items={states}
                                value={state}
                                error={error && error.state}
                                errorMsg={error.state}
                                onChange={(e) => setState(e.target.value)}
                            />
                            <small className="inpLabel">{l.select_city}<span className="redTxt">*</span>:</small>
                            <AddrDropDown
                                placeholder={l.select_city}
                                items={cities}
                                value={city}
                                error={error && error.city}
                                errorMsg={error.city}
                                onChange={(e) => setCity(e.target.value)}
                            />
                            <small className="inpLabel">{l.edit_pin}<span className="redTxt">*</span>:</small>
                            <InputField
                                placeholder={l.edit_pin}
                                type="text"
                                maxLength={15}
                                value={pincode}
                                error={error && error.pincode}
                                errorMsg={error.pincode}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*$/.test(value)) {
                                        setPincode(value); // Only set value if it is numeric
                                    }
                                }}
                            />
                            <small className="inpLabel">{l.edit_clc_domain_name}<span className="redTxt">*</span>:</small>
                            <InputField
                                disabled = {cId}
                                placeholder={l.edit_clc_domain_name}
                                type="text"
                                maxLength="15"
                                error={error && error.domainName}
                                errorMsg={error.domainName}
                                value={domainName}
                                onChange={(e) => setDomainName(e.target.value)}
                            />
                            {/* {domainName !== config.defaultdomian && !cId &&  <Fragment>
                                <small className="inpLabel">{l.congnito_pool_id}<span className="redTxt">*</span>:</small>
                                <InputField
                                    placeholder={l.congnito_pool_id}
                                    type="text"
                                    value={poolId}
                                    error={error && error.poolId}
                                    errorMsg={error.poolId}
                                    onChange={(e) => setPoolId(e.target.value)}
                                />
                                <small className="inpLabel">{l.congnito_identity_pool_id}<span className="redTxt">*</span>:</small>
                                <InputField
                                    placeholder={l.congnito_identity_pool_id}
                                    type="text"
                                    value={identityId}
                                    error={error && error.identityId}
                                    errorMsg={error.identityId}
                                    onChange={(e) => setIdentityId(e.target.value)}
                                />
                                <small className="inpLabel">{l.app_client_id}<span className="redTxt">*</span>:</small>
                                <InputField
                                    placeholder={l.app_client_id}
                                    type="text"
                                    value={appClientId}
                                    error={error && error.appClientId}
                                    errorMsg={error.appClientId}
                                    onChange={(e) => setAppClientId(e.target.value)}
                                />
                                </Fragment>
                            } */}
                            {/* <small className="inpLabel">{l.numb_doctors}<span className="redTxt">*</span>:</small>
                            <InputField
                                placeholder={l.numb_doctors}
                                type="text"
                                value={doctorCount}
                                onChange={(e) => setDoctorCount(e.target.value)}
                            /> */}
                             <small className="inpLabel">{l.numb_doctors}<span className="redTxt">*</span>:</small>
                            <InputField
                                placeholder={l.numb_doctors}
                                type="number"
                                value={doctorsCount}
                                pattern="[0-9]{4}"
                                error={error && error.doctorsCount}
                                errorMsg={error.doctorsCount}
                                onChange={(e) => setDoctorsCount(e.target.value)}
                            />
                            {role === "SA" && !cId && <Fragment>
                                <small className="inpLabel">{l.ass_to}<span className="redTxt">*</span>:</small>
                                <DropDown
                                    placeholder={l.ass_to}
                                    items={admins}
                                    value={assignTo}
                                    error={error && error.assignTo}
                                    errorMsg={error.assignTo}
                                    onChange={(e) => setAssign(e.target.value)}
                                />
                            </Fragment>}
                            <div className="inputRowFeild">
                                <p className="inputRowLabel">{l.doc_prev}</p>
                                <div className="hozRadioGroup">
                                    {/* <div className="rowGroup" >
                                        <Checkbox
                                            onClick={(e) => setAdvice(e.target.checked)}
                                            type="checkbox"
                                            id="1"
                                            name="advice"
                                            checked={advice ? true : false}
                                            for="1"
                                        />
                                        <p className="pTxt">{l.advice}</p>
                                    </div> */}
                                    <div className="rowGroup" >
                                        <Checkbox
                                            onClick={(e) => setUploadPrescription(e.target.checked)}
                                            type="checkbox"
                                            id="2"
                                            checked={uploadPrescription ? true : false}
                                            for="2"
                                        />
                                        <p className="pTxt">{l.upl_presc}</p>
                                    </div>
                                    <div className="rowGroup" >
                                        <Checkbox
                                            onClick={(e) => setPrescription(e.target.checked)}
                                            type="checkbox"
                                            id="3"
                                            checked={prescription ? true : false}
                                            for="3"
                                        />
                                        <p className="pTxt">{l.presc}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="inputRowFeild">
                                <p className="inputRowLabel">{l.pat_prev}</p>
                                <div className="hozRadioGroup">
                                    <div className="rowGroup" >
                                        <Checkbox
                                            onClick={(e) => setScreenShare(e.target.checked)}
                                            type="checkbox"
                                            id="4"
                                            checked={screenShare ? true : false}
                                            for="4"
                                        />
                                        <p className="pTxt">{l.screen_share}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="crdBtnContainer">
                                <div className="rowBlock">
                                    <Button
                                        label={l.cancel}
                                        type='outLine'
                                        size='md'
                                        onClick={handleCancel}
                                    />
                                    <Button
                                        label={cId ? `${l.upd_clinic}` : `${l.crt_clinic}`}
                                        buttonType="submit"
                                        type='primary'
                                        size='md'
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {openPopup &&
                <VerifyPopup openVerify={openPopup} phone={phone.trim()} closePopup={handleVerify} handleVerify={handleVerify} />}
        </Fragment>
    )
}

export default CreateClinicForm;